import { createDeepMemoizedSelector } from 'utils/reduxUtils';

import { types } from './actions';

const initialState = {
  cachedAccounts: [],
  isSearching: false,
  searchResults: [],
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case types.ACCOUNT_SEARCH_ERROR:
      return {
        ...state,
        isSearching: false,
      };
    case types.ACCOUNT_SEARCH_REQUEST:
      return {
        ...state,
        isSearching: true,
      };
    case types.ACCOUNT_SEARCH_SUCCESS:
      return {
        ...state,
        isSearching: false,
        searchResults: payload.searchResults,
      };
    case types.FETCH_ACCOUNT_SUCCESS:
      return {
        ...state,
        cachedAccounts: [...state.cachedAccounts, payload.account],
      };
    case types.RECEIVE_ACCOUNT:
      return {
        ...state,
        cachedAccounts: [...state.cachedAccounts, payload.account],
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) =>
  state.modules.common.smartComponents.accountSelector;

export const getCachedAccounts = createDeepMemoizedSelector(
  (state) => getScope(state).cachedAccounts,
  (cachedAccounts) => cachedAccounts,
);

export const getSearchResults = createDeepMemoizedSelector(
  (state) => getScope(state).searchResults,
  (searchResults) => searchResults,
);

export const getIsSearching = (state) => getScope(state).isSearching;
